function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var SEARCH_TRANSACTIONS_CONSTANTS = {
  BEGIN: 'SEARCH_TRANSACTIONS_BEGIN',
  SUCCESS: 'SEARCH_TRANSACTIONS_SUCCESS',
  FAILURE: 'SEARCH_TRANSACTIONS_FAILURE'
};
export var RETRIEVE_TRANSACTION_CONSTANTS = {
  BEGIN: 'RETRIEVE_TRANSACTION_BEGIN',
  SUCCESS: 'RETRIEVE_TRANSACTION_SUCCESS',
  FAILURE: 'RETRIEVE_TRANSACTION_FAILURE'
};
export var EMAIL_TRANSACTION_CONSTANTS = {
  BEGIN: 'EMAIL_TRANSACTION_BEGIN',
  SUCCESS: 'EMAIL_TRANSACTION_SUCCESS',
  FAILURE: 'EMAIL_TRANSACTION_FAILURE'
};
var SEARCH_TRANSACTIONS_EVENTS = [SEARCH_TRANSACTIONS_CONSTANTS.BEGIN, SEARCH_TRANSACTIONS_CONSTANTS.SUCCESS, SEARCH_TRANSACTIONS_CONSTANTS.FAILURE];
var RETRIEVE_TRANSACTION_EVENTS = [RETRIEVE_TRANSACTION_CONSTANTS.BEGIN, RETRIEVE_TRANSACTION_CONSTANTS.SUCCESS, RETRIEVE_TRANSACTION_CONSTANTS.FAILURE];
var EMAIL_TRANSACTION_EVENTS = [EMAIL_TRANSACTION_CONSTANTS.BEGIN, EMAIL_TRANSACTION_CONSTANTS.SUCCESS, EMAIL_TRANSACTION_CONSTANTS.FAILURE];
export var searchTransactionsPromise = function searchTransactionsPromise(dispatch, customerId, data) {
  if (data.TransactionTypes && data.TransactionTypes.length) {
    data.TransactionTypes = data.TransactionTypes.map(function (type) {
      return type.id;
    });
  }
  return ThunkHelper(dispatch, SEARCH_TRANSACTIONS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchTransactions',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var searchTransactions = function searchTransactions(customerId, data) {
  return function (dispatch) {
    return searchTransactionsPromise(dispatch, customerId, data);
  };
};
var retrieveTransactionPromise = function retrieveTransactionPromise(dispatch, transactionId, customerId, isDbss) {
  return ThunkHelper(dispatch, RETRIEVE_TRANSACTION_EVENTS, {
    method: 'POST',
    url: 'SubscriberManagement/RetrieveTransaction',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      TransactionId: transactionId,
      ReturnReceiptData: true,
      IncludePurchaseInformationThumbnails: true,
      ReturnTransactionRetryIndicator: isDbss || false
    }
  }, {
    transactionId: transactionId
  });
};
export var retrieveTransaction = function retrieveTransaction(transactionId, customerId, isDbss) {
  return function (dispatch) {
    return retrieveTransactionPromise(dispatch, transactionId, customerId, isDbss);
  };
};
export var emailTransaction = function emailTransaction(requestData, customerId) {
  return function (dispatch) {
    return ThunkHelper(dispatch, EMAIL_TRANSACTION_EVENTS, {
      method: 'POST',
      url: 'SubscriberManagement/SendTransactionReceipt',
      headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
      data: requestData
    });
  };
};
export var SET_CURRENT_PAGE = 'SET_TRANSACTIONS_CURRENT_PAGE';
export var setCurrentPage = function setCurrentPage(page) {
  return {
    type: SET_CURRENT_PAGE,
    payload: page
  };
};
export var SET_BRANDABLE_CURRENCY_FILTER = 'SET_TRANSACTIONS_BRANDABLE_CURRENCY_FILTER';
export var setBrandableCurrencyFilter = function setBrandableCurrencyFilter(brandableCurrencyFilter) {
  return {
    type: SET_BRANDABLE_CURRENCY_FILTER,
    payload: brandableCurrencyFilter
  };
};
export var SET_CURRENCY_FILTER = 'SET_TRANSACTIONS_CURRENCY_FILTER';
export var setCurrencyFilter = function setCurrencyFilter(currencyFilter) {
  return {
    type: SET_CURRENCY_FILTER,
    payload: currencyFilter
  };
};
export var SET_LOCKER_FILTER = 'SET_LOCKER_FILTER';
export var setLockerFilter = function setLockerFilter(lockerFilter) {
  return {
    type: SET_LOCKER_FILTER,
    payload: lockerFilter
  };
};
export var SET_PAGE_SIZE_PREFERENCE = 'SET_PAGE_SIZE_PREFERENCE';
export var setPageSizePreference = function setPageSizePreference(pageSize) {
  return {
    type: SET_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};
export var SET_PAYMENT_INSTRUMENT_FILTER = 'SET_TRANSACTIONS_PAYMENT_INSTRUMENT_FILTER';
export var setPaymentInstrumentFilter = function setPaymentInstrumentFilter(paymentInstrumentFilter) {
  return {
    type: SET_PAYMENT_INSTRUMENT_FILTER,
    payload: paymentInstrumentFilter
  };
};
export var SET_TRANSACTION_RESULT_FILTER = 'SET_TRANSACTION_RESULT_FILTER';
export var setTransactionResultFilter = function setTransactionResultFilter(transactionResultFilter) {
  return {
    type: SET_TRANSACTION_RESULT_FILTER,
    payload: transactionResultFilter
  };
};
export var SET_TRANSACTION_TYPE_FILTER = 'SET_TRANSACTIONS_TRANSACTION_TYPE_FILTER';
export var setTransactionTypeFilter = function setTransactionTypeFilter(transactionTypeFilter) {
  return {
    type: SET_TRANSACTION_TYPE_FILTER,
    payload: transactionTypeFilter
  };
};
export var UPDATE_DATE_RANGE = 'UPDATE_TRANSACTIONS_DATE_RANGE';
export var updateDateRange = function updateDateRange(startDate, endDate) {
  return {
    type: UPDATE_DATE_RANGE,
    payload: {
      startDate: startDate,
      endDate: endDate
    }
  };
};
export var SHOW_SUBSCRIPTION_BANNER = 'SHOW_SUBSCRIPTION_BANNER';
export var showSubscriptionBanner = function showSubscriptionBanner(showBanner) {
  return {
    type: SHOW_SUBSCRIPTION_BANNER,
    payload: showBanner
  };
};
export var CLEAR_TRANSACTIONS_ERROR = 'CLEAR_TRANSACTIONS_ERROR';
export var clearTransactionsError = function clearTransactionsError() {
  return {
    type: CLEAR_TRANSACTIONS_ERROR
  };
};
export var EMPTY_TRANSACTIONS_LIST = 'EMPTY_TRANSACTIONS_LIST';
export var emptyTransactionsList = function emptyTransactionsList() {
  return {
    type: EMPTY_TRANSACTIONS_LIST
  };
};
export var REMOVE_TRANSACTIONS_FILTER = 'REMOVE TRANSACTIONS_FILTER';
export var removeTransactionsFilter = function removeTransactionsFilter() {
  return {
    type: REMOVE_TRANSACTIONS_FILTER
  };
};